<template>
    <div class="summary">
        <template v-if="step === 5">
            <h4 class="h4">{{ t('whenAndWhere') }}</h4>
            {{ t('station') }}:
            <strong>
                {{ station.name }}<br />
                {{ station.street }}, {{ station.postcode }} {{ station.city }}<br />
                {{ station.telephone }}
            </strong>
            {{ t('when') }}:
            <strong>{{ dateAndTime }}</strong>
            {{ t('people') }}:
            <strong>{{ order.data.value.persons }}</strong>
            <h4 class="h4">{{ t('food') }}</h4>
            {{ t('foodChoice') }}:
            <strong>{{ order.data.value.food }}</strong>
            {{ t('allergies') }}:
            <strong>{{ order.data.value.allergies }}</strong>
            <h4 class="h4">{{ t('contactInfo') }}</h4>
            {{ t('contactPerson') }}:
            <strong>{{ order.data.value.contact }}</strong>
            {{ t('phone') }}:
            <strong>{{ order.data.value.phone }}</strong>
            {{ t('email') }}:
            <strong>{{ order.data.value.email }}</strong>
        </template>
        <template v-else-if="step >= 2 && step < 6">
            <div v-if="order.data.value.station">{{ t('station') }}: <strong>{{ station.name }}</strong></div>
            <div v-if="order.data.value.date && order.data.value.time">{{ t('when') }}: <strong>{{ dateAndTime }}</strong></div>
        </template>
    </div>
</template>
<script setup>
import { computed, inject, useI18n } from '#imports';

const order = inject('order');

defineOptions({
    inheritAttrs: false,
});

defineProps({
    step: {
        type: Number,
        required: false,
        default: 0,
    },
    station: {
        type: Object,
        required: false,
        default: () => ({}),
    },
});

const dateAndTime = computed(() => {
    if (order.data.value.date && order.data.value.time) {
        return `${order.data.value.date} ${t('hour')} ${order.data.value.time}`;
    }

    return null;
});

const { t } = useI18n({
    useScope: 'global',
    messages: {
        'fi-FI': {
            whenAndWhere: 'Missä ja milloin',
            station: 'Asema',
            when: 'Päivämäärä',
            people: 'Henkilömäärä',
            food: 'Ruokatoive',
            foodChoice: 'Ruokatoiveet',
            allergies: 'Allergiat / erityisruokavaliot',
            contactInfo: 'Yhteystiedot',
            contactPerson: 'Yhteyshenkilö',
            address: 'Osoite',
            phone: 'Puhelinnumero',
            email: 'Sähköposti',
            hour: 'klo',
        },
        'en-EU': {
            whenAndWhere: 'Missä ja milloin',
        },
    },
});
</script>
<style scoped>
.summary {
  display: grid;
  margin-bottom: 1rem;
}

.h4 {
  margin-bottom: 0.5rem;
}
</style>
